var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDominica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9131 39.6161C31.8196 38.0477 38.0478 31.8194 39.6162 23.913H23.9131V39.6161Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.383789 23.913C1.95215 31.8194 8.18043 38.0477 16.0869 39.6161V23.913H0.383789Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6162 16.0869C38.0478 8.18051 31.8196 1.95223 23.9131 0.383789V16.0869H39.6162Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0869 0.383789C8.18043 1.95223 1.95215 8.18051 0.383789 16.0869H16.0869V0.383789Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6957 23.913H16.087V39.6161C16.9384 39.7849 17.8092 39.8993 18.6957 39.9564V23.913Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6957 16.0869V0.043457C17.8092 0.100488 16.9383 0.214941 16.087 0.383769V16.0869H18.6957Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3044 0.0435156C20.873 0.015625 20.4384 0 20.0001 0C19.5617 0 19.1271 0.015625 18.6957 0.0435156V16.087H21.3043V0.0435156H21.3044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6957 39.9564C19.1271 39.9843 19.5617 39.9999 20.0001 39.9999C20.4384 39.9999 20.873 39.9843 21.3044 39.9564V23.913H18.6958V39.9564H18.6957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.087 18.6956V16.0869H0.383892C0.214985 16.9383 0.10061 17.8091 0.0435791 18.6956H16.087Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9131 18.6956H39.9566C39.8996 17.8091 39.7851 16.9383 39.6163 16.0869H23.9132V18.6956H23.9131Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9131 21.3043H39.9566C39.9844 20.873 40 20.4383 40 19.9999C40 19.5616 39.9844 19.1269 39.9565 18.6956H23.9131V21.3043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0435156 18.6956C0.0157031 19.1269 0 19.5616 0 19.9999C0 20.4383 0.0157031 20.873 0.0435156 21.3043H16.087V18.6956H0.0435156V18.6956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 29.5652C25.2828 29.5652 29.5653 25.2827 29.5653 19.9999C29.5653 14.7172 25.2828 10.4347 20.0001 10.4347C14.7173 10.4347 10.4348 14.7172 10.4348 19.9999C10.4348 25.2827 14.7173 29.5652 20.0001 29.5652Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1794 21.0672C21.4679 19.6443 20.5431 18.2021 20.5431 18.2021C20.5431 18.2021 20.5661 17.5455 20.5661 17.1542C20.5661 16.5648 20.0883 16.087 19.4989 16.087C18.9405 16.087 18.483 16.516 18.4364 17.0622C17.9973 17.0909 17.6499 17.4551 17.6499 17.9013C17.6499 18.2258 17.8337 18.507 18.1028 18.6475C18.2365 18.3347 18.4984 18.0905 18.8223 17.9791C18.8751 18.0223 18.9319 18.0609 18.9924 18.0937L19.1291 18.1591C19.1291 18.1591 18.6222 19.5881 18.6222 20.3558C18.6222 22.5139 20.0451 23.1795 20.0451 23.1795V23.2017L19.3336 23.9131H20.7565V22.4902L21.468 23.2016C21.4743 23.1883 22.8157 22.3399 22.1794 21.0672V21.0672Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 12.174L20.3238 13.1704H21.3715L20.5239 13.7862L20.8477 14.7826L20.0001 14.1668L19.1524 14.7826L19.4762 13.7862L18.6287 13.1704H19.6763L20.0001 12.174Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 13.6687L16.2475 14.2845L17.0952 13.6686L16.7714 14.6651L17.6191 15.2808L16.5713 15.2809L16.2476 16.2773L15.9238 15.2809L14.8761 15.2808L15.7237 14.665L15.4 13.6687Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.557 17.5817H13.6046L13.9284 16.5853L14.2522 17.5817L15.2999 17.5817L14.4523 18.1976L14.7761 19.194L13.9284 18.5781L13.0808 19.1939L13.4045 18.1975L12.557 17.5817Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.557 22.4183L13.4045 21.8026L13.0808 20.8062L13.9284 21.422L14.7761 20.8062L14.4523 21.8026L15.3 22.4184L14.2522 22.4185L13.9284 23.4148L13.6046 22.4183H12.557Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 26.3315L15.7236 25.3352L14.876 24.7194H15.9237L16.2475 23.7229L16.5713 24.7193H17.619L16.7714 25.3352L17.0951 26.3316L16.2475 25.7157L15.4 26.3315Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 27.8262L19.6763 26.83H18.6287L19.4762 26.214L19.1524 25.2176L20.0001 25.8333L20.8476 25.2175L20.5239 26.214L21.3715 26.8299L20.3238 26.83L20.0001 27.8262Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 26.3315L23.7525 25.7157L22.905 26.3317L23.2286 25.3352L22.381 24.7194L23.4287 24.7193L23.7524 23.7229L24.0763 24.7194H25.1239L24.2764 25.3352L24.6 26.3315Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.443 22.4184H26.3955L26.0716 23.4149L25.7479 22.4185H24.7001L25.5477 21.8026L25.2239 20.8063L26.0716 21.4221L26.9191 20.8063L26.5955 21.8027L27.443 22.4184Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.443 17.5817L26.5955 18.1974L26.9192 19.1938L26.0716 18.5781L25.224 19.194L25.5477 18.1975L24.7001 17.5817L25.7479 17.5816L26.0716 16.5853L26.3955 17.5817H27.443Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 13.6686L24.2764 14.6649L25.1239 15.2808H24.0763L23.7525 16.2772L23.4287 15.2808L22.381 15.2809L23.2286 14.6649L22.9049 13.6687L23.7525 14.2844L24.6 13.6686Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominica);
export default __webpack_public_path__ + "static/media/dominica.6155368565ac125d820ba3156fa998da.svg";
export { ForwardRef as ReactComponent };